import React from 'react';
import * as styles from './detailedCurriculum.module.scss';

const PageFooter = () => {
  return (
    <footer>
      <div className={styles.wrap}>
        <img
          src="https://www.crio.do/static/5ac1a39f9eebf6fe904e14069500353e/63cb2/Crio_Dark.png"
          alt="Crio.Do"
        />
        <div>20, 100 Feet Rd, Bengaluru 560095 · support@criodo.com · 080424 53955</div>
        <div>#LearnByDoing</div>
      </div>
    </footer>
  );
};

export default PageFooter;
